import emojiRegex from "emoji-regex";
import {
    AnyObject,
    ArraySchema,
    addMethod,
    array as yupArray,
    string as yupString
} from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

addMethod(yupString, "blockEmojiRHF", function () {
    return this.test("blockEmoji", function (value) {
        if (!emojiRegex().test(value || "")) {
            return true;
        }
        return this.createError({
            message: () => () => (t: Translate) =>
                t("general.form.input.validation.emoji.invalid")
        });
    });
});

addMethod<
    ArraySchema<
        Array<{ fileSize: number }> | undefined,
        AnyObject,
        undefined,
        ""
    >
>(yupArray, "filesize", function (maxSizeInBytes: number) {
    return this.test("filesize", function (value) {
        if (!value) return true;

        return (
            value.reduce((acc, file) => acc + file.fileSize, 0) <
                maxSizeInBytes ||
            this.createError({
                path: this.path,
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.filesize",
                        Math.round(maxSizeInBytes / (1024 * 1024))
                    )
            })
        );
    });
});

addMethod<
    ArraySchema<
        Array<{ fileType: string; fileName: string }> | undefined,
        AnyObject,
        undefined,
        ""
    >
>(
    yupArray,
    "fileTypes",
    function (
        acceptedFileTypes: Array<{ mime: string; extensions: Array<string> }>
    ) {
        return this.test("fileTypes", function (value) {
            if (!value) return true;
            let invalidFileName: string | undefined;

            value.forEach((file) => {
                const isValid = acceptedFileTypes.some(
                    (type) =>
                        file.fileType === type.mime &&
                        type.extensions.some((ext) =>
                            file.fileName.toLowerCase().endsWith(ext)
                        )
                );
                if (!isValid) {
                    invalidFileName = file.fileName;
                }
            });

            return (
                invalidFileName === undefined ||
                this.createError({
                    path: this.path,
                    message: () => () => (t: Translate) =>
                        t("form.validation.input.filetype", invalidFileName)
                })
            );
        });
    }
);

export const string = () => {
    return yupString().trim().blockEmojiRHF();
};

export const message = (maxLength: number) =>
    string().nullable().required().max(maxLength);

export const optionalMessage = (maxLength: number) =>
    string().nullable().max(maxLength);

export const storeId = string()
    .nullable()
    .required(
        () => () => (t: Translate) =>
            t("form.validation.input.storeId.required")
    );

export const category = string().nullable().required();

export const optionalOrderId = string().nullable().max(100);

export const recaptcha = string().nullable().required();
